import {Question} from '../shared/question';
import {Response} from '../shared/response';

export class OneToOneSegment4Win{

    question1:Question;
    question2:Question;
    question3:Question;
    question4:Question;

    questions: Array<Question>;


    constructor(){
        this.question1 = new Question(1, [], 
            'In cursul lunii septembrie, ai primit din partea Winston un pachet gratuit, pe care il puteai revendica din magazin. Pentru a intra in posesia pachetului, trebuia folosit un cod de revendicare, disponibil in sectiunea “Contul meu”, de pe platforma Winston “Your Freedom”. Ulterior, codul ti-a fost trimis prin SMS.',
            'Iti amintesti sa fi primit o astfel de comunicare? ',
            'radio',
            [new Response(1, 'Da'), 
            new Response(2, 'Nu')
            ],
            false
        );
        
        this.question2 = new Question(2, [1],
            'Ne poti spune care este motivul pentru care nu ai revendicat pachetul gratuit ?',
            '',
            'checkbox-free',
            [new Response(1, 'Nu m-a atras cadoul oferit (1 pachet tigarete Winston)'), 
            new Response(2, 'Nu am inteles ce sortiment de Winston imi este oferit'),
            new Response(3, 'Nu am gasit stoc disponibil'),
            new Response(4, 'Nu am gasit magazin in apropiere'),
            new Response(5, 'Nu cunosc platforma Your Freedom'),
            new Response(6, 'Nu doresc sa am cont in platforma Your Freedom'),
            new Response(7, 'Nu am inteles pasii necesari pentru activarea contului / ce am de facut – vreau sa ma sune cineva si sa-mi ofere asistenta'),
            new Response(8, 'Nu am inteles pasii necesari pentru activarea contului / ce am de facut – nu vreau sa fiu sunat, ma descurc singur pe viitor'),
            new Response(9, 'Mi s-a parut prea complicat procesul'),
            new Response(10, 'Altele'),
            ],
            false
        );
    
        this.question2.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            return question1SelectedIds.length> 0 && question1SelectedIds.indexOf(1) >= 0;
        }

        this.question3 = new Question(3, [1,2],
            'Participi in campanii promotionale, in general, indiferent de categorie sau produs?',
            '',
            'radio',
            [new Response(1, 'Da'),
            new Response(2, 'Nu')
            ],
            false
        );

        this.question3.render = ()=>{
            let question1SelectedIds = this.getSelectedAnswersIds(this.question1);
            let question2SelectedIds = this.getSelectedAnswersIds(this.question2);
            return (question1SelectedIds.length> 0 && question1SelectedIds.indexOf(2) >= 0) || 
                (question2SelectedIds.length > 0);
        }

        this.question4 = new Question(4, [3],
            'Exista un factor care te-ar face sa te razgandesti? Daca da, care?',
            '',
            'checkbox-free',
            [new Response(1, 'Nu'),
            new Response(2, 'Da')
            ],
            true
        );
        this.question4.render = ()=>{
            let question3SelectedIds = this.getSelectedAnswersIds(this.question3);
            return question3SelectedIds.length> 0 && question3SelectedIds.indexOf(2) >= 0;
        }

        

        this.questions = [this.question1, this.question2, this.question3, this.question4];
    }

    
    getQuestions():Array<Question>{
        return this.questions;
    }

    getSelectedAnswersIds(question:Question):Array<Number>{
        return question.responses.filter(r => r.selected).map(r => r.id);
    } 
    
}

